import { Currency, METIS, Token } from '@hyperjump-defi/sdk'

export function currencyId(currency: Currency): string {
  if (currency === METIS) return 'METIS'
  if (currency instanceof Token) return currency.address
  throw new Error('invalid currency')
}

export default currencyId
